import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-column"
}
const _hoisted_2 = { class: "filter-bar fixed-top w-100 d-flex py-2 align-items-center justify-content-start" }
const _hoisted_3 = {
  key: 0,
  class: "logo-icon d-flex justify-content-center"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-spinner fa-pulse fa-2x text-primary" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "logo-icon d-flex justify-content-center"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://loupey.io/media/nr0pyvyt/louper-mark-1.svg",
  alt: "",
  width: "30",
  class: "d-inline-block align-text-top"
}, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "container-fluid d-flex justify-content-between" }
const _hoisted_10 = { class: "d-flex flex-row align-items-center justify-content-start" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-cog text-primary" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-right" }, [
  /*#__PURE__*/_createElementVNode("div", { id: "filter-bar-content" })
], -1)
const _hoisted_13 = { class: "d-flex flex-row" }
const _hoisted_14 = {
  id: "router-content",
  class: "d-flex flex-column",
  style: {"width":"calc(100% - 64px)"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_user_account_picker = _resolveComponent("user-account-picker")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_menu_bar = _resolveComponent("menu-bar")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_loading, {
      active: !_ctx.$auth.authenticated,
      isErrored: _ctx.$auth.error,
      "is-full-page": true,
      onRetryRequested: _cache[0] || (_cache[0] = ($event: any) => {this.$auth.loginWithRedirect();}),
      errorMessage: this.$auth.error
    }, null, 8, ["active", "isErrored", "errorMessage"]),
    (_ctx.$auth.authenticated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, [
              (_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
                : (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_user_account_picker),
                _createVNode(_component_router_link, {
                  to: { name: 'account'},
                  class: "ms-2"
                }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                })
              ]),
              _hoisted_12
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_menu_bar),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_router_view)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}